type SearchInputProps = {
    value: string;
    onSearch: (value: string) => void;
    placeholder?: string;
};

export const SearchInput = ({ value, onSearch, placeholder = 'Search' }: SearchInputProps) => (
    <div className='table-toolbar-search input-group'>
        <span className='input-group-addon'>
            <span className='uikit-icon icon-search' />
        </span>
        <div className='ClearableInput input-group'>
            <input
                placeholder={placeholder}
                className='form-control'
                type='text'
                value={value}
                onChange={e => onSearch(e.target.value)}
            />
            <span className='clearButton hide'>
                <span className='clearButtonIcon uikit-icon icon-remove-sign' />
            </span>
        </div>
    </div>
);
